import { render, staticRenderFns } from "./form_stars_balance_component.vue?vue&type=template&id=8910bd18&scoped=true"
import script from "./form_stars_balance_component.vue?vue&type=script&lang=js"
export * from "./form_stars_balance_component.vue?vue&type=script&lang=js"
import style0 from "./form_stars_balance_component.vue?vue&type=style&index=0&id=8910bd18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8910bd18",
  null
  
)

export default component.exports